<template>
<div>历史</div>
</template>

<script>
export default {
name: "history"
}
</script>

<style scoped>

</style>
